<div class="daisy-card bg-base-100 border border-error/30 shadow-sm mt-6">
  <div class="daisy-card-body">
    <h3 class="daisy-card-title text-error flex items-center gap-2">
      <i class="fa-solid fa-triangle-exclamation"></i>
      Danger Zone: Delete Account
    </h3>
    <p class="text-sm text-base-content/80 mt-2">
      Deleting your account is permanent and cannot be undone. All of your
      personal data, course enrollments, progress, and profile details will be
      permanently removed.
    </p>
    <div class="daisy-alert daisy-alert-warning text-xs mt-3">
      <i class="fa-solid fa-circle-info"></i>
      <span>
        <strong>Notice:</strong> In compliance with legal regulations, payment
        transaction history and invoices will be retained for financial audit
        purposes.
      </span>
    </div>
    <div class="daisy-card-actions justify-end mt-4">
      <button
        type="button"
        class="daisy-btn daisy-btn-error"
        (click)="openConfirmModal()"
      >
        <i class="fa-solid fa-trash-can"></i>
        Delete My Account
      </button>
    </div>
  </div>
</div>

<!-- Confirmation Modal -->
<input
  type="checkbox"
  id="delete-confirm-modal"
  class="daisy-modal-toggle"
  [checked]="isModalOpen"
/>
<div class="daisy-modal" role="dialog">
  <div class="daisy-modal-box">
    <h3 class="text-lg font-bold text-error flex items-center gap-2">
      <i class="fa-solid fa-triangle-exclamation"></i>
      Confirm Account Deletion
    </h3>
    <p class="py-4 text-sm text-base-content/80">
      This action is <strong>permanent</strong> and cannot be undone. To
      confirm, please type your email/username
      <code class="bg-base-200 px-1 py-0.5 rounded font-mono font-bold">{{
        userEmail
      }}</code>
      below.
    </p>

    <div class="daisy-form-control w-full mt-2">
      <input
        type="text"
        [(ngModel)]="confirmEmailInput"
        placeholder="Type email to confirm"
        class="daisy-input daisy-input-bordered w-full"
        [class.daisy-input-error]="confirmEmailInput && !isEmailMatched"
      />
    </div>

    <div class="daisy-modal-action">
      <button
        type="button"
        class="daisy-btn daisy-btn-ghost"
        (click)="closeConfirmModal()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="daisy-btn daisy-btn-error"
        [disabled]="!isEmailMatched"
        (click)="confirmDelete()"
      >
        I understand, delete my account
      </button>
    </div>
  </div>
  <label class="daisy-modal-backdrop" (click)="closeConfirmModal()"
    >Close</label
  >
</div>
